// extracted by mini-css-extract-plugin
export default {"modal_wrapper":"styles_modal_wrapper__tQz0D","video_box":"styles_video_box__u9rl+","close_btn_wrapper":"styles_close_btn_wrapper__VIVlT","videoPlayer":"styles_videoPlayer__lSszZ"};